import {cl} from "../library/common";
// Import our custom CSS
import '../scss/part.scss'
import '../library/filters';
import '../library/backtotopbutton';
import "../library/dropdown";
//import '../library/topbarclass';
//import '../library/searchbar';

// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

import '../library/responsivelazyload';
import '../library/smoothscroller';
/*
AOS - Animate Scroll Library
wenn nicht gebraucht auskommentieren
*/
import '../library/aos';

/*
GSAP - (GreenSock Animation Platform) Animate anything
wenn nicht gebraucht auskommentieren
*/
import '../library/gsap';

/*
High Quality Web Icons
Simple Open Source icons carefully crafted for designers & developers
wenn nicht gebraucht auskommentieren

import '../library/boxicons';
 */

/*
Swiper (https://swiperjs.com/)
The Most Modern Mobile Touch Slider
wenn nicht gebraucht auskommentieren
 */

import '../library/swiper';


/*
Parallax-js (wagerfield.github.io/parallax/)
Parallax Engine that reacts to the orientation of a smart device. Where no gyroscope or motion detection hardware is available, the position of the cursor is used instead.
wenn nicht gebraucht auskommentieren

import '../library/parallax';
 */

/*
Jarallax (github.com/nk-o/jarallax)
wenn nicht gebraucht auskommentieren

import '../library/jarallax';
 */


/* Same heigth for home-hero layers */
function adjustPageContentHeightHero() {
    const homeHero = document.getElementById("home-hero-inner");
    const pageContent = document.getElementById("home-hero");

    if (homeHero && pageContent) {
        const homeHeroHeight = homeHero.offsetHeight;
        pageContent.style.height = `${homeHeroHeight}px`;
    }
}
// Initial
document.addEventListener("DOMContentLoaded", adjustPageContentHeightHero);
// Screen size
window.addEventListener("resize", adjustPageContentHeightHero);
